module.exports = "/static/assets/7f943e03dbb86eddfde951af1c5bafc1.png";